module.exports = __webpack_public_path__ + "static/media/zanwujiangli.e2d05764.png";


//////////////////
// WEBPACK FOOTER
// ./src/views/activity_130/imgs/zanwujiangli.png
// module id = 379
// module chunks = 0